/**
 * Logout glue pre natívnu wrapper appku — po odhlásení zmaže WebView
 * session/storage, nech na zdieľanom zariadení nezostane relácia ani tracking
 * predošlého používateľa.
 *
 * KANONICKÝ ZDROJ: r-flutter-wrapper/docs/web/app-logout.js — verziované spolu
 * s bridge kontraktom (docs/bridge-contract.md). Kópie v eshopoch lokálne
 * neupravovať; zmeny robiť tu a rozkopírovať.
 *
 * Ako to funguje: jadro rshopu (rshop/frontend `LoginTrait::logout`) nastaví po
 * odhlásení krátkotrvajúci `logged_out` cookie. Tento skript ho po page load-e
 * prečíta, v appke zavolá `CLEAR_SESSION` (zmaže WebView cookies/localStorage/
 * cache) a cookie zmaže, nech sa akcia nezopakuje. Mimo appky cookie len zmaže
 * (no-op wipe). Nezávisí od toho, ako sa logout spustil (link, expirácia
 * session, programovo) — na rozdiel od naviazania na konkrétny DOM selektor.
 *
 * Vyžaduje načítaný app-bridge.js (`window.AppBridge`) — načítať PO ňom. Vite/
 * TS eshopy: `import "<cesta-v-eshope>/app-logout.js"` (side-effect, žiadne
 * exporty) po importe app-bridge.esm.
 *
 * **Migrácia s ešte živým starým wrapperom** (Median/GoNative alebo vlastný
 * wrapper, ktorých appky sú v storoch, kým si ich používatelia neupdatujú):
 * ten má obvykle vlastný logout skript čítajúci ten istý cookie. Tento modul by
 * mu ho mimo našej appky zmazal skôr, než ho stihne prečítať, a starým appkám by
 * logout wipe tichо prestal fungovať. Vtedy nastav **pred** načítaním tohto
 * modulu `window.__appLogoutConfig = { keepCookieOutsideApp: true }` — cookie
 * mimo našej appky nechá starému skriptu (ten si ho zmaže sám) a zároveň si
 * v starom skripte pridaj guard `if (!window.AppBridge?.isApp)`, nech si obe
 * cesty neprelezú cookie navzájom.
 */
(function () {
    "use strict";

    const COOKIE = "logged_out";

    const hasLoggedOutCookie = () =>
        document.cookie.split("; ").some((entry) => entry.indexOf(COOKIE + "=") === 0);

    const deleteLoggedOutCookie = () => {
        document.cookie = COOKIE + "=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
    };

    if (!hasLoggedOutCookie()) {
        return;
    }

    const bridge = window.AppBridge;

    if (bridge && bridge.isApp) {
        bridge
            .callBridge("CLEAR_SESSION")
            .catch((error) => {
                if (window.console) {
                    console.warn("[app-logout] CLEAR_SESSION zlyhal:", error);
                }
            })
            .then(deleteLoggedOutCookie);
    } else if ((window.__appLogoutConfig || {}).keepCookieOutsideApp !== true) {
        // mimo appky cookie nič nespúšťa — zmaž, nech neostáva visieť.
        // Migrácia s ešte živým starým wrapperom si to vypína (viď hlavička).
        deleteLoggedOutCookie();
    }
})();
